<template>
  <b-row class="dashboard-indicadores-historico-gastos-ventas">
    <b-col cols="12">
      <label class="titulo" v-if="showTitulo">Gastos/Ventas</label>
      <b-table hover
          responsive="sm" 
          class="registro"
          :busy="tableBusy"
          :items="indicadoresGastosVentas" 
          :fields="indicadoresGastosVentasFields">
        <div slot="table-busy" class="text-center">
          <b-spinner class="table-spinner" label="Spinning" />
        </div>
        <template v-slot:cell(pjeObjetivo)="data">
          {{ data.item.pjeObjetivo | porcentaje }}
        </template>
        <template v-slot:cell(montoNetoVentas)="data">
          {{ data.item.montoNetoVentas | moneda }}
        </template>
        <template v-slot:cell(montoNetoGastos)="data">
          {{ data.item.montoNetoGastos | moneda }}
        </template>
        <template v-slot:cell(montoNetoSueldos)="data">
          {{ data.item.montoNetoSueldos | moneda }}
        </template>
        <template v-slot:cell(montoNetoImpuestos)="data">
          {{ data.item.montoNetoImpuestos | moneda }}
        </template>
        <template v-slot:cell(pjeActual)="data">
          {{ data.item.pjeActual | porcentaje }}
        </template>

        <!-- <template v-slot:cell(detailShowing)="row">
          <b-btn class="detailShowing" 
              size="sm" 
              @click.stop="row.toggleDetails">
            {{ ( row.detailsShowing) ? '-' : '+' }}
          </b-btn>            
        </template> -->

        <!-- <template v-slot:row-details="row">
          <b-row>
            <b-col cols="12">
              <p>Información del Indicador:</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="2">
              <p class="descripcion">Ventas</p>
            </b-col>
            <b-col cols="10">
              <p class="descripcion">{{ row.item.montoNetoVentas | moneda }}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="2">
              <p class="descripcion">Compras</p>
            </b-col>
            <b-col cols="10">
              <p class="descripcion">{{ row.item.montoNetoCompras | moneda }}</p>
            </b-col>
          </b-row>
        </template> -->
      </b-table>
    </b-col>
  </b-row>
</template>

<script>

export default {
  props: {
    showTitulo: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      indicadoresGastosVentas: [],
      indicadoresGastosVentasFields: [
        // {
        //     key: 'detailShowing',
        //     label: '',
        //     class: 'text-center'
        // },
        { 
          key: 'indicadorPeriodo',
          label: 'Periodo' 
        },
        { 
          key: 'pjeObjetivo',
          class: 'text-right'
        },
        { 
          key: 'montoNetoVentas',
          label: 'Ventas',
          class: 'text-right'
        },
        { 
          key: 'montoNetoGastos',
          label: 'Gastos',
          class: 'text-right'
        },
        { 
          key: 'montoNetoSueldos',
          label: 'Sueldos',
          class: 'text-right'
        },
        { 
          key: 'montoNetoImpuestos',
          label: 'Impuestos',
          class: 'text-right'
        },
        { 
          key: 'pjeActual',
          label: 'Pje Real',
          class: 'text-right'
        },
        { 
          key: 'descripcion',
          label: 'Descripción'
        },
        // {
        //   key: 'opciones',
        //   label: '',
        //   class: 'text-center'
        // }
      ],

      tableBusy: false,
    }
  },
  created() {
  },
  methods: {
    getIndicadores() {
        this.tableBusy = true;
        this.$store.dispatch('resultadosIndicadores/getIndicadoresGastosVentasHistorico')
          .then(() => {
            this.indicadoresGastosVentas = this.$store.getters['resultadosIndicadores/indicadoresGastosVentasHistorico'];
            this.tableBusy = false;
          });
    },
  }
}
</script>

<style>
  .dashboard-indicadores-historico-gastos-ventas .registro table td[aria-colindex="1"] {
    width: 15% !important;
  }
  .dashboard-indicadores-historico-gastos-ventas .registro table td[aria-colindex="2"],
  .dashboard-indicadores-historico-gastos-ventas .registro table td[aria-colindex="3"],
  .dashboard-indicadores-historico-gastos-ventas .registro table td[aria-colindex="4"],
  .dashboard-indicadores-historico-gastos-ventas .registro table td[aria-colindex="5"],
  .dashboard-indicadores-historico-gastos-ventas .registro table td[aria-colindex="6"],
  .dashboard-indicadores-historico-gastos-ventas .registro table td[aria-colindex="7"]
  {
    width: 12% !important;
  }
  .dashboard-indicadores-historico-gastos-ventas .registro table td[aria-colindex="8"]
  {
    width: 13% !important;
  }
</style>